import { z } from "zod";

export const SensorAgentVersionChangeSchema = z.object({
  id: z.number().int().optional(),
  sensor_agent_version: z.string().trim().min(1),
  changed_at: z.string().optional(),
  changed_by: z.string().trim().min(1),
});

export type SensorAgentVersionChange = z.infer<
  typeof SensorAgentVersionChangeSchema
>;
